import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { styled, ToggleButton, ToggleButtonGroup } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "space-evenly",
  width: "100%",
});

const LayoutCardWrapper = styled("div")({
  borderRadius: "16px",
  display: "flex",
  width: "100%",
  paddingRight: "10px",
});

function InvestmentsDesktop({ app, config }) {
  const { cards } = config.investments;
  const { title } = cards[0];
  const [id, setId] = useState("e397858c-2730-4a5d-8720-fa1bb3dd276b");
  const [buttonGroup, setButtonGroup] = useState([
    { value: "Resumo", selected: true },
    { value: "Detalhado", selected: false },
  ]);
  const [selectedYear, setSelectedYear] = useState("FY24");
  const { selections } = useSelections();

  useEffect(() => {
    if (selections.length) {
      async function checkYear() {
        let newYear =
          selections.find((selection) => selection.qField === "Ano")
            ?.qSelected ?? null;

        if (newYear === "FY23") {
          setSelectedYear("FY23");
          setId("e41b8db2-deb9-4c41-9a12-7bd7e160d5cc");
          setButtonGroup(null);
        } else {
          if (selectedYear === "FY23") {
            app.field("%Tipo_Sel_Inv").selectMatch("Resumo");
            setButtonGroup([
              { value: "Resumo", selected: true },
              { value: "Detalhado", selected: false },
            ]);
            setId("e397858c-2730-4a5d-8720-fa1bb3dd276b");
          } else {
            const found = buttonGroup.find((element) => element.selected);
            if (found.value) {
              setId(
                found.value === "Resumo"
                  ? "e397858c-2730-4a5d-8720-fa1bb3dd276b"
                  : "928416ae-6447-460d-9163-52ddf2309b99"
              );
            }
          }
          setSelectedYear("FY24");
        }
      }
      checkYear();
    }
  }, [app, selections]);

  useEffect(() => {
    const found = buttonGroup?.find((element) => element.selected);
    if (found) {
      app.field("%Tipo_Sel_Inv").selectMatch(found.value);
    }
  }, [app, buttonGroup]);

  return (
    <div className="app investments">
      <div className="appContent">
        <LayoutCardsWrapper>
          <LayoutCardWrapper></LayoutCardWrapper>
          {/* KPIS */}
          <LayoutCardWrapper style={{ height: "100%" }}>
            <Card
              exportTable
              app={app}
              exportTableId={id}
              header={{
                hardTitle: title.hardTitle,
                tooltip: title.tooltip,
              }}
              buttonGroup={buttonGroup}
              buttonFunction={setButtonGroup}
              style={{ width: "100%", alignItems: "center" }}
            >
              <NativeObject
                app={app}
                key={id}
                reference={{ id: id }}
                style={{ marginTop: "20px" }}
              />
            </Card>
          </LayoutCardWrapper>
          {/* KAPI E GRAFICO CENTRAL */}
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

InvestmentsDesktop.defaultProps = {
  app: null,
  config: {},
};

InvestmentsDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default InvestmentsDesktop;
